import React, { useState, useEffect } from "react";
import LoginSignup from "../Authentication/LoginSignup";
import * as styles from "../newStyles.styles";
import { isMobileDevice } from "helpers";
import { SlidingCarousel, TextBox } from "components";
import Footer from "../Footer";
import Header from "../Header";
import CurrentFeatures from "./CurrentFeatures";
import SupportFeatures from "./SupportFeatures";
import PowerBox from "./PowerBox";
import { textBoxConstants, testimonials } from "../../constants";
import MessengerCustomerChat from "react-messenger-customer-chat";
import CalendyForm from "../MarketingLandingPage/CalendyForm";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

// import Drift from "react-driftjs";

const pictures = [
  "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg",
];

function Landing({ history }) {
  const [sliderProgress, setSliderProgress] = useState(20);

  const [scrollToMarketPlace, setScrollToMarketPlace] = useState(false);

  /************************************************************************************************
   ************************************************************************************************
   * formatter function
   * This function converts a number into decimal format, for US price.
   ************************************************************************************************
   ************************************************************************************************/
  var formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  });
  /************************************************************************************************
   ************************************************************************************************
   * appDownloads function
   * This function ensures the correct number of downloads is shown. Special case is 1000 since the
   * comma needs to be included.
   ************************************************************************************************
   ************************************************************************************************/
  const appDownloads = () => {
    if (sliderProgress != 1000) {
      return formatter.format(Math.round(sliderProgress / 10) * 10);
    } else {
      return "1,000";
    }
  };

  /************************************************************************************************
   ************************************************************************************************
   * revenue function
   * This function returns a string that will be displayed as the revenue.
   ************************************************************************************************
   ************************************************************************************************/
  const revenue = () => {
    if (appDownloads() != 1000 && appDownloads() != "1,000") {
      return "$" + formatter.format(appDownloads() * 10);
    } else {
      return "$" + formatter.format(1000 * 10);
    }
  };
  // Render TextBoxes
  const renderTextBoxes = () => {
    let reverse = false;
    return (
      <div>
        {textBoxConstants.map((textBox) => {
          reverse = !reverse;
          // console.log(reverse);
          return (
            <PowerBox
              header={textBox.header}
              text={textBox.text}
              bullets={textBox.bullets}
              imgSrc={textBox.imgSrc}
              reverse={reverse}
              key={textBox.header}
            ></PowerBox>
          );
        })}
      </div>
    );
  };

  const isMob = isMobileDevice();
  const scrollTo = (ref) => {
    if (ref && scrollToMarketPlace /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setScrollToMarketPlace(false);
  };

  const mobileText = isMob
    ? "Visit Us On Desktop To Try For Free!"
    : "Try Building Your Free App Now!";
  return (
    <div className={styles.body}>
      {/* <Drift appId="twraffmhtism" /> */}
      <div className={styles.wrapper}>
        {/*************************************************************************************************
         **************************************************************************************************
         * Header Row
         * Row that includes the company logo at the top left corner, and the menu on the top right
         * Menu will change to 3 bars if its on mobile
         **************************************************************************************************
         **************************************************************************************************/}
        <Header history={history} />
        {/* <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1}>
              <TextBox
                // header="COVID-19 Update"
                text="As a company whose core mission is to help small businesses succeed, we are cutting our monthly fee by over 50% when you sign up for one year. We are also offering free consulting services with our customer success team representatives. For more information, contact us!"
              ></TextBox>
            </div>
          </div>
        </div> */}
        {/************************************************************************************************
         *************************************************************************************************
         * Hero Row
         * Row that includes the hero text, hero image, and call to action button
         *************************************************************************************************
         ************************************************************************************************/}
        <div className={styles.row} style={{ marginTop: "30px" }}>
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1_4}>
              <styles.H1MainHeader>
                Launch your <br />
                e-commerce presence in{" "}
                <span style={{ color: "#89d2d3" }}>30 minutes.</span>
              </styles.H1MainHeader>
              <styles.P style={{ fontSize: "18px", lineHeight: "1.875" }}>
                From a mobile applet, web storefront, loyalty programs, to
                integrated shipping and customer management, we packaged
                everything you need to build an e-commerce experience in 30
                minutes!
                {/* Using our no code mobile app builder, you can build, customize
                and launch a mobile app and website to the{" "}
                <span
                  style={{
                    color: "#89d2d3",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => setScrollToMarketPlace(true)}
                >
                  Mobile360 Marketplace{" "}
                </span>
                in just 30 minutes. No technical or design skill required, we
                promise. 
                <br />
                <br />
                Streamline your small business and reengage customers with
                Fortune 500 technology. Affordably. */}
              </styles.P>
              <LoginSignup
                buttonText="Get Started for Free"
                fontWeight="bold"
                fontSize="20px"
              />
            </div>
            <div className={styles.col + " " + styles.col3pic}>
              {/* <LazyLoadImage
                src={
                  "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                } // use normal <img> attributes as props
                wrapperClassName={styles.heroImage}
                alt="hero-image"
                effect="opacity"
                delayTime={500}
              /> */}
              {/* <ImageLoad
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                placeholder=""
                className={styles.heroImage}
                alt="Decription"
              /> */}
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                className={styles.heroImage}
                alt="hero-image"
              ></img>
            </div>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={styles.inner}>
              <div className={styles.innerContainer}>
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Dead Simple</h2>
                <p className={styles.innerParagraph}>
                  No coding. No difficult design decisions. No integrations. No
                  extra steps for hosting or app stores.
                </p>
              </div>
              <div
                className={
                  styles.innerContainer + " " + styles.innerContainerPadding
                }
              >
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Easy customer engagement</h2>
                <p className={styles.innerParagraph}>
                  Share your download link or QR code with your customers to
                  engage them with push notifications and content.
                </p>
              </div>
              <div
                className={
                  styles.innerContainer + " " + styles.innerContainerPadding
                }
              >
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Community benefits</h2>
                <p className={styles.innerParagraph}>
                  Large companies get beneficial rates for things like payment
                  processing and shipping; you should too!
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div
              className={styles.col + " " + styles.col1}
              style={{ textAlign: "-webkit-center" }}
            >
              <styles.H2
                style={{
                  marginBottom: "60px",
                  marginTop: "60px",
                }}
              >
                Mobile360 App{" "}
                <span className={styles.styledUnderline}>Marketplace</span> and
                Website
              </styles.H2>
            </div>

            {/* <div className={styles.col + " " + styles.col1_customImg}>
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobile_marketplace.png"
                className={styles.heroImage}
                alt="hero-image"
              ></img>
            </div> */}
            <div className={styles.flexyRowBlock}>
              <div
                className={
                  styles.col1_4_pic + " " + styles.col + " " + styles.mobile_pic
                }
                style={{ paddingTop: "0px" }}
              >
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobile_marketplace.png"
                  style={{ width: "280px" }}
                  alt="mobile-marketplace"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col1_custom2}>
                <styles.P style={{ lineHeight: "1.875" }}>
                  Building mobile apps and websites are extremely difficult and
                  expensive, but are vital to a business’ success. We’ve made it
                  simpler and more affordable than ever.
                  <br />
                  <br />
                  By hosting your customized app and website on our marketplace,
                  we take care of the costs, complexity, and maintenance of a
                  traditional app and website. You’ll have all the tools you
                  need to build a successful business right here, so that you
                  can focus on what’s most important.
                </styles.P>
                <div className={styles.buttonRow}>
                  <a
                    href={"/power-of-marketplace"}
                    style={{ color: "rgb(137, 210, 211)", fontSize: "18px" }}
                    className={styles.marginBottom}
                  >
                    Learn About the Marketplace Benefits
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CurrentFeatures />

        <div
          className={styles.row}
          style={{
            marginBottom: "0px",
            padding: "30px 10px",
            paddingTop: "0px",
            backgroundImage: "linear-gradient(135deg,#89d2d3,#b1dada)",
          }}
        >
          <div className={styles.maxWidthWrapper}>
            <div
              className={styles.col + " " + styles.col1}
              style={{ textAlign: "-webkit-center" }}
            >
              <styles.H2
                style={{
                  marginBottom: "40px",
                  marginTop: "40px",
                  width: "275px",
                }}
              >
                How it <span className={styles.styledUnderline}>Works</span>
              </styles.H2>
            </div>
            <div className={styles.col + " " + styles.col1_custom2}>
              <styles.P style={{ lineHeight: "1.875" }}>
                Use our super simplified point-and-click builder to create the
                mobile app and web experience you’ve been dreaming of. No code,
                no difficult design decisions.
                <br />
                <br />
                We host your e-commerce experience on our marketplace mobile app
                and website, cutting out the costs and complexity of launching a
                traditional app or website.
              </styles.P>
              <div className={styles.buttonRow}>
                <a
                  href={"/how-it-works"}
                  style={{ color: "black", fontSize: "18px" }}
                  className={styles.marginBottom}
                >
                  Learn More
                </a>
                <div className={styles.marginBottom}>
                  <LoginSignup
                    buttonText="Start Building for Free"
                    fontWeight="bold"
                    fontSize="20px"
                  />
                </div>
              </div>
            </div>
            <div className={styles.col + " " + styles.col1_customImg}>
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/app_builder_overview.png"
                className={styles.heroImage}
                style={{ width: "100%" }}
                alt="hero-image"
              ></img>
            </div>
          </div>
        </div>

        <div
          className={styles.row}
          style={{
            marginBottom: "0px",
            padding: "30px 10px",
          }}
        >
          <div className={styles.maxWidthWrapper}>
            <div
              className={styles.col + " " + styles.col1}
              style={{ textAlign: "-webkit-center" }}
            >
              <styles.H2
                style={{
                  marginBottom: "40px",
                  marginTop: "30px",
                  textAlign: "left",
                }}
              >
                Strength in{" "}
                <span className={styles.styledUnderline}>Numbers</span>
              </styles.H2>
              <styles.P style={{ lineHeight: "1.875", textAlign: "left" }}>
                Mobile360 is so much more than a no code mobile app and website
                builder. We’re a community of enthusiastic small businesses
                owners that want to share their passion with the world, and
                consumers who want to support those businesses. By joining
                forces under one roof, we bring some key benefits to you:
              </styles.P>
            </div>
            <div className={styles.inner}>
              <div className={styles.innerContainer}>
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Free Marketing</h2>
                <p className={styles.innerParagraph}>
                  Get discovered by customers across the country already on
                  Mobile360.
                </p>
              </div>
              <div
                className={
                  styles.innerContainer + " " + styles.innerContainerPadding
                }
              >
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Essential Partnerships</h2>
                <p className={styles.innerParagraph}>
                  We negotiate great rates and partnerships to pass benefits
                  directly on to you that are typically reserved for large
                  corporations.
                </p>
              </div>
              <div
                className={
                  styles.innerContainer + " " + styles.innerContainerPadding
                }
              >
                <hr className={styles.innerLine} />
                <h2 className={styles.innerH2}>Advertising</h2>
                <p className={styles.innerParagraph}>
                  We run social media ads to bring customers to our marketplace,
                  and your business.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className={styles.row}
          style={{
            marginBottom: "0px",
            padding: "30px 10px",
            paddingTop: "0px",
            backgroundImage: "linear-gradient(135deg,#89d2d3,#b1dada)",
          }}
        >
          <div className={styles.maxWidthWrapper}>
            <div
              className={styles.col + " " + styles.col1}
              style={{ textAlign: "-webkit-center" }}
            >
              <styles.H2
                style={{
                  marginBottom: "60px",
                  marginTop: "60px",
                  textAlign: "left",
                }}
              >
                The truth is…
              </styles.H2>
              <styles.P style={{ lineHeight: "1.875", textAlign: "left" }}>
                Small businesses drive the economy. Yet, they are the most
                underserved when it comes to technology. At Mobile360, we set
                out to empower small businesses with the simplest way to setup
                everything they need for an e-commerce business, with technology
                at its core. We don’t think you need to be a multi million
                dollar business to unlock benefits that only large corporations
                have access to. Together, we can reshape the landscape for small
                businesses.
                <br />
                <br />
                <a
                  href={"/our-mission"}
                  style={{ color: "black" }}
                  className={styles.marginBottom}
                >
                  Learn More About Our Mission
                </a>
              </styles.P>
            </div>
          </div>
        </div>

        <div className={styles.row}>
          {/************************************************************************************************
           *************************************************************************************************
           * Schedule a Demo Row
           * This row is for Calendy Demo scheduling
           *************************************************************************************************
           ************************************************************************************************/}
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1}>
              <styles.H2
                style={{
                  textAlign: "center",
                  width: "100%",
                  marginBottom: "30px",
                }}
              >
                Schedule a Free 30 Minute{" "}
                <span className={styles.styledUnderline}>Demo</span>
              </styles.H2>

              <br></br>
              <CalendyForm />
            </div>
          </div>
        </div>
        {/************************************************************************************************
         *************************************************************************************************
         * Get Discovered By Row
         *************************************************************************************************
         ************************************************************************************************/}
        {/* <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1}>
              <styles.H2
                style={{
                  marginBottom: "30px",
                  marginTop: "60px",
                }}
              >
                Get Discovered by{" "}
                <span className={styles.styledUnderline}>New</span> Customers!
              </styles.H2>
            </div>
            <div className={styles.col + " " + styles.col1_custom}>
              <styles.P>
                What’s better than having a mobile app and website for only your
                loyal customers? Getting new customers of course! 😃
                <br />
                <br />
                Showcase your business’ products and offerings to{" "}
                <span className={styles.styledUnderline}>NEW</span> customers
                using the Mobile360 Marketplace. 🛍
                <br />
                <br />
                Gain customers from across the country that are excited to
                support small and local businesses, like yours!
              </styles.P>
            </div>
            <div className={styles.col + " " + styles.col3pic_custom}>
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/marketplace_download_overview.png"
                className={styles.heroImage}
                style={{ width: "100%" }}
                alt="hero-image"
              ></img>
            </div>
          </div>
        </div> */}

        {/************************************************************************************************
         *************************************************************************************************
         * Get Discovered By Row
         *************************************************************************************************
         ************************************************************************************************/}
        {/* <div className={styles.row} style={{ background: "#89d2d3" }}>
          <div
            className={styles.maxWidthWrapper}
            style={{ marginBottom: "30px" }}
          >
            <div className={styles.col + " " + styles.col1}>
              <styles.H2
                style={{
                  marginBottom: "30px",
                  marginTop: "60px",
                }}
              >
                We've Got Your Back with{" "}
                <span className={styles.styledUnderline}>24/7</span> Support
              </styles.H2>
            </div>
            <div className={styles.col + " " + styles.col1_half}>
              <styles.P>
                Creating your mobile app and website is just the beginning of
                our relationship. 🤝🏽
                <br />
                <br />
                Our team is here to support you through every step of your
                business’ journey, beyond technology. 😊
                <br />
                <br />
                You’ll have a dedicated customer success agent you can text
                whenever you need. 🙌
              </styles.P>
            </div>
            <div
              className={styles.col + " " + styles.col3pic_half}
              style={{ justifyContent: "center", textAlign: "center" }}
            >
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Support-Team.png"
                className={styles.customImage}
                alt="support-image"
              ></img>
            </div>
          </div>
        </div> */}

        {/* <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1}>
              <styles.H2
                style={{
                  marginBottom: "0px",
                  marginTop: "60px",
                }}
              >
                We’re more than an app and website builder.
                <br />
                We’re your:
              </styles.H2>
            </div>

            <div className={styles.col}>
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Teams.gif"
                alt="Content URL Widget Examples"
                style={{ width: "100%", marginTop: "40px" }}
                sizes="(max-width: 1024px) 100vw, 1024px"
                data-ll-status="loaded"
              ></img>
            </div>
          </div>
        </div> */}

        {/* <div className={styles.row} style={{ marginTop: "30px" }}> */}
        {/************************************************************************************************
         *************************************************************************************************
         * Slider Row
         * Row that includes the iphone carousel with img srcs from s3 instance. Also includes text
         * for What is Mobile360 marketplace
         *************************************************************************************************
         ************************************************************************************************/}
        {/* <div className={styles.col + " " + styles.col1}>
            <H1 style={{ fontSize: "30px" }}>What can Mobile360 do for you?</H1>
            <br></br>
            <div className={styles.row + " " + sliderLabel}> */}
        {/* Values above the slider */}
        {/* <P className={small}>20</P>
              <P className={small}>1000+</P>
            </div>
            <div className={slideContainer}> */}
        {/* Values for the slider logic */}
        {/* <input
                onChange={(e) => setSliderProgress(e.target.value)}
                type="range"
                min="20"
                max="1000"
                value={sliderProgress}
                className={slider}
              />
            </div>
            <P style={{ fontSize: "18px" }}>
              With{" "}
              <span style={{ color: "#89D2D3", fontSize: "24px" }}> */}
        {/* See function above for logic calculation for appDownloads */}
        {/* {appDownloads()}
              </span>{" "}
              of your customers on Mobile360, you can achieve up to{" "}
              <span style={{ color: "#89D2D3", fontSize: "24px" }}> */}
        {/* See function above for logic calculation for revenue */}
        {/* {revenue()}
              </span>{" "}
              in additional revenue. Move the slider around to see more!
            </P>
            <P>
              *Based on an average additonal spend of $10 per customer per
              month, through your app!
            </P>
          </div>
        </div> */}
        {/************************************************************************************************
         *************************************************************************************************
         * Power Statements Row
         * Row that includes the boxes for power statements and text. Just make a new TextBox component and
         * include a header and text.
         *************************************************************************************************
         ************************************************************************************************/}
        {/* <a ref={scrollTo}></a>
        {renderTextBoxes()}
        <div
          style={{ maxWidth: "1200px", margin: "auto", marginBottom: "60px" }}
        >
          {" "}
          <styles.H2
            style={{ textAlign: "center", width: "100%", marginTop: "60px" }}
          >
            Experience the Simplicity{" "}
            <span className={styles.styledUnderline}>Yourself!</span>
          </styles.H2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "60px",
              marginTop: "60px",
            }}
          >
            <iframe
              className={styles.frameStyleLanding}
              src={"https://www.youtube.com/embed/KfqTXzzw8Ow?controls=0"}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={true}
              modestbranding
              frameBorder="0"
            ></iframe>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "30px 0px",
              width: "100%",
            }}
          >
            <LoginSignup
              buttonText="Try It Yourself!"
              fontWeight="bold"
              fontSize="20px"
            />
          </div>
        </div> */}
        <div
          style={{ width: "100%", paddingBottom: "30px" }}
          className={styles.offwhite}
        >
          <div
            style={{ marginBottom: "30px", maxWidth: "1200px", margin: "auto" }}
          >
            <SlidingCarousel></SlidingCarousel>
          </div>
        </div>

        <div
          className={styles.row}
          style={{
            backgroundImage: "linear-gradient(135deg,#89d2d3,#b1dada)",
            marginBottom: "0px",
          }}
        >
          <div className={styles.maxWidthWrapper}>
            <div className={styles.col + " " + styles.col1}>
              <styles.H2 style={{ width: "100%" }}>
                The Mobile360 App Marketplace
              </styles.H2>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "40px",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                  }}
                >
                  {testimonials.map((t, idx) => {
                    // console.log("got testimonials: " + testimonials.length);
                    // console.log(t.name + ": " + idx);
                    if (idx > 3)
                      return (
                        <div key={t.name}>
                          <div className={styles.imageCropper}>
                            <img
                              className={styles.logoStyle}
                              src={t.logo}
                              alt={t.name}
                            ></img>
                          </div>
                        </div>
                      );
                  })}
                </div>
                <img
                  className={styles.appsImage}
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobileApps.svg"
                />
                <div
                  style={{
                    display: "inline-block",
                  }}
                >
                  {testimonials.map((t, idx) => {
                    // console.log("got testimonials: " + testimonials.length);
                    // console.log(t.name + ": " + idx);
                    if (idx < 3)
                      return (
                        <div key={t.name}>
                          <div className={styles.imageCropper}>
                            <img
                              className={styles.logoStyle}
                              src={t.logo}
                              alt={t.name}
                            ></img>
                          </div>
                        </div>
                      );
                  })}
                </div>
              </div>

              <styles.P style={{ lineHeight: "1.875" }}>
                <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                  Looking to support small businesses?
                </span>
                <br />
                Mobile360 brings you a vast array of small businesses you can
                support from around the country. Simply download our marketplace
                app to get started!
              </styles.P>
              <styles.P
                style={{
                  marginBottom: "30px",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Download the Marketplace App
              </styles.P>
              <div style={{ marginTop: "2em", marginBottom: "1em" }}>
                <div className={styles.bouncingArrow}>
                  <ArrowDownwardIcon fontSize="large" />
                </div>
              </div>
              <div
                className={styles.flexyRowCol}
                style={{ marginBottom: "30px" }}
              >
                <a
                  href="https://apps.apple.com/us/app/mobile360/id1466921046"
                  target="_blank"
                >
                  <img
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/apple-store.svg"
                    // style={{ height: "75px" }}
                    alt="Download on the app store logo png"
                    className={styles.appleStore}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.mobile360.android"
                  target="_blank"
                >
                  <img
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/google-play-store.svg"
                    // width="257"
                    // height="112"
                    alt="google play itunes png logo"
                    className={styles.googlePlayStore}
                  />
                </a>
              </div>
              <styles.P style={{ lineHeight: "1.875", textAlign: "center" }}>
                <a
                  href={"/support-small-business"}
                  style={{ color: "black" }}
                  className={styles.marginBottom}
                >
                  Learn More about Supporting Small Businesses
                </a>
              </styles.P>
            </div>
          </div>
        </div>

        {/************************************************************************************************
         *************************************************************************************************
         * Carousel Iphone Row
         * Row that includes the iphone carousel with img srcs from s3 instance. Also includes text
         * for What is Mobile360 marketplace. The offwite style above refers to the light
         * green blue background.
         *************************************************************************************************
         ************************************************************************************************/}
        {/* <div className={row + " " + offwhite}>
          <div className={col + " " + col1_4_pic}>
            <div className={hostElement}>
              <Carousel
                style={{
                  position: "relative",
                  height: "365px",
                  width: "213px",
                  top: "45px",
                  left: "7px",
                }}
                time={3000}
              >
                <FrameImg
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/1.png"
                  alt="phone-frame-1"
                />
                <FrameImg
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/2.png"
                  alt="phone-frame-2"
                />
                <FrameImg
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/3.png"
                  alt="phone-frame-3"
                />
                <FrameImg
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/4.png"
                  alt="phone-frame-4"
                />
                <FrameImg
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/carousel/5.png"
                  alt="phone-frame-5"
                />
              </Carousel>
            </div>
          </div> */}
        {/* <div className={col + " " + col3}>
            <H1>What is the Mobile360 marketplace? </H1>
            <P style={{ fontSize: "18px" }}>
              Let’s be honest, downloading apps is sacred to most people. That’s
              why we created the Mobile360 marketplace. All apps created on
              Mobile360 get hosted in the marketplace. Your customers download
              the Mobile360 app and can manage all their favorite apps within.
            </P>
          </div> */}
        {/* </div> */}
        {/* <div className={styles.row}>
            <div className={styles.col + " " + styles.col1}> */}

        <SupportFeatures />
        <div className={styles.row}>
          {/************************************************************************************************
           *************************************************************************************************
           * Call to action Row
           * This row is supposed to be for subscription sign up, but we have omitted that with a cta button
           * instead.
           *************************************************************************************************
           ************************************************************************************************/}
          <div className={styles.col + " " + styles.col1}>
            {/* <H1>{mobileText}</H1> */}
            {/* <br></br>
            <form>
            <input
              autoComplete="new-email"
              className={subscribeInput}
              autoFocus='email'
              name='email'
              type='text' 
              // value={email}
              placeholder='Enter your email address'
              // onChange={this.update} 
              />
            <Button className={mdcButton} raised 
            // onClick={this.submit}
            >Subscribe</Button>  
            </form> */}
            <styles.H1 style={{ fontSize: "20px" }}>
              Don't Miss This Introductory Offer<br></br>
            </styles.H1>
            <br></br>
            <LoginSignup
              buttonText="Try Building Your Free App Now"
              fontSize="16px"
            />
          </div>
        </div>
        <MessengerCustomerChat
          pageId="108776007365384"
          appId="181854830587947"
          themeColor="#465362"
          loggedInGreeting="Hey! Interested in a mobile app & website? Let's chat!"
          loggedOutGreeting="Hey! Interested in a mobile app & website? Let's chat!"
        />
        <Footer />
      </div>
    </div>
  );
}

export default Landing;
